export default "__VITE_ASSET__BdVGM_uG__"